import axios from 'axios'
import QS from 'qs'

let APP_URL
if(process.env.NODE_ENV === 'development'){
  // APP_URL = 'http://192.168.88.106:10901'
  APP_URL = 'http://47.94.143.98:50007/'
} else if(process.env.NODE_ENV === 'production'){
  APP_URL = 'https://publicapi.houbaoyan.cn'
} else if(process.env.NODE_ENV === 'debug'){
  APP_URL = 'http://debug.com'
}

const request = axios.create({
  baseURL: APP_URL,
  timeout: 5000
})

request.interceptors.request.use(config => {
  // 配置token
  return config
},
error => {
  return Promise.reject(error)
})

request.interceptors.response.use(
  response => {
    // console.log(response, 'response');
    if(response.data.status === 200){
      console.log('axios 200', response);
      return Promise.resolve(response)
    } else {
      // 处理错误状态码
      //return response
      // console.log('axios 报错了', response);
      return Promise.reject(response)
    }
  }, 
  err => {
    if (err.message === 'Network Error') {
      Message({
        message: err.message + ',请联系技术人员',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
    // 请求错误
    if (err.response) {
      Message({
        message: err.response.data.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(err)
    }
  }
)

// content-Type: application/json
export function get (url, params) {
  return request({
    url,
    method: 'get',
    params: params
  })
}

export function get1 (url, params) {
  return request({
    url,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: params
  })
}

// 序列化。content-Type: application/x-www-form-urlencoded
export function post (url, params) {
  return request({
    url,
    method: 'post',
    data: QS.stringify(params)
  })
}

// post接口：content-Type: application/json
export function post1 (url, params) {
  return request({
    url,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default request



// WEBPACK FOOTER //
// ./src/request/request.js